const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoFeeManagementQuery: any = {
    CompanyList: Backofficebff + '/v1/cargo/companylist',
    CompanyListV2: Backofficebff + '/v1/cargo/companylist-v2',
    GetDistanceType: Backofficebff + '/v1/cargofeemanagement/distancetype',
    DepartureLocationType: Backofficebff + '/v1/cargofeemanagement/departurelocationtype',
    GetFilteredShippingCompanyPrices: Backofficebff + '/v1/cargofeemanagement/getfilteredshippingcompanyprices',
};
